import React from "react"

import { ArticleJsonLd, NextSeo } from 'next-seo'

import Config from '../../site.config'
import {
    buildRelativePath,
    getImagesListSEO
} from '../../lib/images/image'

const ArticleSEO = ({ metadata, url, slug }) => {
  const { title, date, image, author, description, tag } = metadata
  const postURL = `${url}${buildRelativePath(slug)}`
  const imagesList = getImagesListSEO(url, slug, image)
  const image2Show = imagesList[0]

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={postURL}
        openGraph={{
          type: 'article',
          article: {
            publishedTime: `${date}`,
            modifiedTime: `${date}`,
            authors: [`${author}`],
            tags: [`${tag}`],
          },
          url: `${postURL}`,
          images: [
            {
              url: `${image2Show}`,
              width: 480,
              height: 371,
              alt: `Imagen de ${slug}`,
            },
          ],
          site_name: 'Romikya Labs',
        }}
      />
      <ArticleJsonLd
        type='BlogPosting'
        url={postURL}
        title={title}
        images={imagesList}
        datePublished={date}
        dateModified={date}
        authorName={author}
        description={description}
      />
    </>
  )
}

ArticleSEO.defaultProps = {
  title: 'Romikya',
  url: Config.site.URL,
  slug: '',
}

export default ArticleSEO;